import { DetailsCard, DetailsCardItem } from '@components/detailsCard';
import { Loader } from '@components/loader';
import { PermissionsAccordion } from '@components/permissionsAccordion';
import { TwoFactorSetupContextProvider } from '@ctx/twoFactor/provider';
import { TwoFactorSection } from '@pages/settings/twoFactorSection';
import { UpdatePasswordSection } from '@pages/settings/updatePaswordSection';
import { AcquirerUser } from '@root/globalTypes';
import { useGetPermissionGroups } from '@services/acquirer/users/permissionGroups';
import { useSessionUser } from '@services/global/session/user';
import { createFileRoute } from '@tanstack/react-router';
import { FileText, Landmark, Mail, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function AcquirerSettings() {
  const { t } = useTranslation('app');
  const { data, isPending } = useSessionUser<AcquirerUser>();
  const { data: permissions } = useGetPermissionGroups();

  if (isPending) return <Loader />;
  if (!data) return null;

  return (
    <div className="flex flex-col gap-4">
      <DetailsCard title={t('pages.settings.userDetails.title')}>
        <DetailsCardItem
          icon={<Mail size={26} />}
          data={data.email}
          label={t('table.email')}
          column={1}
        />
        <DetailsCardItem
          icon={<User size={26} />}
          data={data.name}
          label={t('table.name')}
          column={1}
        />
        <DetailsCardItem
          icon={<FileText size={26} />}
          data={data.description}
          label={t('table.description')}
          column={1}
        />
        <DetailsCardItem
          icon={<Landmark size={26} />}
          data={data.acquirer.name}
          label={t('table.acquirer')}
          column={2}
        />
      </DetailsCard>
      {permissions && (
        <PermissionsAccordion permissions={permissions} selectedPermissions={data.permissions} />
      )}
      <TwoFactorSetupContextProvider user={data}>
        <TwoFactorSection />
      </TwoFactorSetupContextProvider>
      <UpdatePasswordSection userType="acquirer" />
    </div>
  );
}

export const Route = createFileRoute('/u/$localId/_acquirer/acquirer/settings/')({
  component: AcquirerSettings,
});
